var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpeed = function SvgSpeed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.118 11.586a.63.63 0 0 1-.631.63h-2.591a.631.631 0 1 1 0-1.262h1.937a8.83 8.83 0 0 0-2.575-5.64 8.83 8.83 0 0 0-5.64-2.575V4.84a.631.631 0 1 1-1.263 0v-2.1a8.83 8.83 0 0 0-5.177 2.144L6.73 6.437a.631.631 0 0 1-.893.893L4.285 5.776a8.83 8.83 0 0 0-2.145 5.178h1.938a.631.631 0 1 1 0 1.263H1.487a.63.63 0 0 1-.632-.632c0-2.591.99-5.185 2.968-7.164C7.779.466 14.194.466 18.15 4.422a10.1 10.1 0 0 1 2.967 7.164"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.094 6.478a.63.63 0 0 1 0 .893l-3.277 3.277a2.056 2.056 0 1 1-.893-.893l3.277-3.277a.63.63 0 0 1 .893 0m-5.107 5.901a.794.794 0 1 0 0-1.587.794.794 0 0 0 0 1.587",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.032 14.409c.349 0 .632.282.632.631V17h1.96a.631.631 0 1 1 0 1.262h-1.96v1.96a.631.631 0 0 1-1.263 0v-1.96h-1.96a.631.631 0 0 1 0-1.262h1.96v-1.96c0-.349.283-.631.631-.631M1.72 17.631c0-.349.282-.631.63-.631H6.67a.631.631 0 1 1 0 1.262H2.35a.63.63 0 0 1-.63-.631"
  })));
};
export default SvgSpeed;